import { render, staticRenderFns } from "./OrganAllocation.vue?vue&type=template&id=3114f16c"
import script from "./OrganAllocation.vue?vue&type=script&lang=js"
export * from "./OrganAllocation.vue?vue&type=script&lang=js"
import style0 from "./OrganAllocation.vue?vue&type=style&index=0&id=3114f16c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports